import React from "react";
import Avatar from "../Avatar";

class SiteAvatar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { avatar } = this.props;
        const image = avatar !== "default.png" 
            ? `/api/file/profile_pictures/${avatar}` 
            : null;

        return (
            <Avatar {...this.props} image={image} />
        )
    }
}

export default SiteAvatar;